module.exports = __webpack_public_path__ + "img/20210314_120356.23a2b762.jpg";